(function () {
    angular.module('st')
        .controller('AllMoviesController', [
            '$rootScope', '$scope', "$timeout", "$http",
            function ($rootScope, $scope, $timeout, $http) {
                var ctrl = this;
                var defaultRatingsOrder = ["G", "PG", "PG13", "PG-13", "R", "NC-17", "NR", "TBC"];

                ctrl.filterOptions =  {
                    searchTerm: null,
                    genres: null,
                    date: null,
                    category: null,
                    ratings: null
                }

                ctrl.genres = null;
                ctrl.categories = null;
                ctrl.dates = null;
                ctrl.ratings = null;

                ctrl.movies = null;

                ctrl.AOSRefresh = function() {
                    $timeout(function() {
                        AOS.refreshHard();
                    }, 500);
                }

                $scope.init = function (json) {
                    ctrl.movies = json;
                    try {
                        var tempratings = [...new Set(json.map(function(item){ return item.Rating; }))].sort() || null;
                        ctrl.ratings = tempratings.sort((a, b) => {
                            const aIndex = defaultRatingsOrder.indexOf(a);
                            const bIndex = defaultRatingsOrder.indexOf(b);
                            return aIndex - bIndex;
                        });
                    } catch (error) {
                        ctrl.ratings = null;
                    }
                    try {
                        
                        ctrl.genres = [...new Set(json.flatMap(function(item){ return [...item.Genres]; }))].sort() || null;
                    } catch (error) {
                        ctrl.genres = null;
                    }

                    //console.log('r', ctrl.ratings);
                    //console.log('g', ctrl.genres);
                    AOS.init({once: false});
                }        

                $scope.$watchCollection('amc.moviesFiltered', function() { 
                    //console.log('filtered');
                    ctrl.AOSRefresh();
                });        

                $scope.filterByOptions = function(item) {
                    var passesFilter = true;
                    //console.log('filters', ctrl.filterOptions);

                    if (ctrl.filterOptions.searchTerm) {
                        if (item.Title.toLowerCase().includes(ctrl.filterOptions.searchTerm.toLowerCase())) {
                            //do nothing it passes
                        } else {
                            passesFilter = false;
                        }
                    }
        
                    if (ctrl.ratings) {
                        if (ctrl.filterOptions.ratings) {
                            if (ctrl.filterOptions.ratings.indexOf(item.Rating) > -1) {
                                //do nothing it passes
                            } else {
                                passesFilter = false;
                            }
                        }
                    }
        
                    if (ctrl.genres) {
                        if (ctrl.filterOptions.genres) {
                            var casedItemGenres = item.Genres.map(v => v.toLowerCase());
                            if (casedItemGenres.indexOf(ctrl.filterOptions.genres.toLowerCase()) > -1) {
                            //if (ctrl.filterOptions.genres.toLowerCase().indexOf(casedItemGenres) > -1) {
                                //do nothing it passes
                            } else {
                                passesFilter = false;
                            }
                        }
                    }

                    if (passesFilter) {
                        return item;
                    }
                }

            }]);
})();

